import type { ILocationV2 } from '@sravni/types/lib/locations';

export const DEFAULT_LOCATION: ILocationV2 = {
  id: 83,
  garId: 1405113,
  name: 'Москва',
  fullName: 'г. Москва',
  fullNameShortened: 'г. Москва',
  nameLocative: 'в Москве',
  nameGenitive: 'Москвы',
  alias: 'moskva',
  route: '6.83.',
  routeGar: '1405113',
  localityType: 'город',
  shortLocationType: 'г.',
  latitude: 55.7540471,
  longitude: 37.620405,
  fias: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
  kladr: '7700000000000',
  okato: '45000000000',
  oktmo: '45000000',
  isoCode: 'RU-MOW',
  geoNameId: '524901',
  timeZoneId: 'Europe/Moscow',
  utc: 'UTC+3',
  country: 'russia',
  regionCode: '77',
  regionIsoCode: 'RU-MOW',
  regionKladr: '7700000000000',
  regionGeoNameId: '524901',
  regionOkato: '45000000000',
  regionOktmo: '45000000',
  regionRoute: '6.83.',
  regionRouteGar: '1405113',
};
